import css from 'styled-jsx/css';
import { MQ_LARGE } from 'constants/mq';
import { warmGrays } from 'styles/colors/constants';

export default css`
  .PrismEntryButton--button {
    display: flex;
    align-items: flex-end;
    padding-right: 0.5rem;
    color: ${warmGrays[6]};
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    border: none;
  }

  .PrismEntryButton__icon {
    margin-right: 0.5rem;
    height: 20px;
    width: 20px;
  }

  .PrismEntryButton__text {
    /* Magic number to visually center the text */
    margin-bottom: 0.125em;
  }

  @media ${MQ_LARGE} {
    .PrismEntryButton__icon {
      opacity: 0.5;
      transition: opacity 0.2s ease-in;
    }

    /* 
    We want to activate the hover state when the reader hovers 
    anywhere over the image
    */
    :global(.ImageCollectionGallery__galleryItem:hover .PrismEntryButton__icon),
    :global(.StaticPrismPage__galleryItem:hover .PrismEntryButton__icon),
    :global(.ImageSlider:hover .PrismEntryButton__icon),
    :global(.Figure:hover .PrismEntryButton__icon),
    /* disable the hover styles when the thumbnail view is ACTIVE */
    :global(.SlideGallery:not(.SlideGallery--thumbnails-active):hover
        .PrismEntryButton__icon),
    /* hover selector for thumbnail view */
    :global(.SlideGallery--thumbnails-active li:hover .PrismEntryButton__icon) {
      opacity: 1;
    }
  }
`;
